import http from '@/utils/http'
// import axios from 'axios'

// const http = axios.create({
//   baseURL: '/',
//   timeout: 50000,
//   headers: {
//     'Content-Type': 'application/json;charset=UTF-8'
//   }
// })

/**
 * 发起SDK支付
 * @param {*} data
 * @returns
 */
export function postJsSDKPayment(data, token) {
  return http.post('/js/payment', data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
}
